// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import {
  AdminGetNormalRooms,
  AdminGetRooms,
  AdminUploadImages,
} from './roomsServiceSync';

const initialState = {
  roomLoading: false,
  roomImageLoader: false,
  rooms: [],
  normalRooms: [],
  roomError: null,
  roomMessage: '',
  current_room: '',
  messages: null,
  selectedRoom: {},
  roomImageDetails: [],
};

export const adminRoomSlice = createSlice({
  name: 'admin_room',
  initialState,
  reducers: {
    reset: (state) => {
      state.roomLoading = false;
      state.roomImageLoader = false;
      state.rooms = [];
      state.normalRooms = [];
      state.roomError = [];
      state.roomMessage = '';
      state.current_room = '';
      state.messages = null;
      state.selectedRoom = {};
      state.roomImageDetails = [];
    },

    updateRoom: (state, { payload }) => {
      state.rooms = payload;
    },

    updateNormalRoom: (state, { payload }) => {
      state.normalRooms = payload;
    },

    updateCurrentRoom: (state, { payload }) => {
      state.current_room = payload;
    },

    updateCurrentNormalRoom: (state, { payload }) => {
      state.current_room = payload;
    },

    updateMessage: (state, { payload }) => {
      state.messages = payload;
    },

    updateSelectedRoom: (state, { payload }) => {
      state.selectedRoom = payload;
    },

    updateRoomMessageDetails: (state, { payload }) => {
      state.roomImageDetails = payload;
    },

    updateSelectedNormalRoom: (state, { payload }) => {
      state.selectedRoom = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AdminGetRooms.pending, (state) => {
        state.roomLoading = true;
      })
      .addCase(AdminGetRooms.fulfilled, (state, { payload }) => {
        state.roomLoading = false;
        state.rooms = payload.data;
        state.roomMessage = payload.message;
      })
      .addCase(AdminGetRooms.rejected, (state, { payload }) => {
        state.roomLoading = false;
        state.roomMessage = payload.message;
      });

    builder
      .addCase(AdminGetNormalRooms.pending, (state) => {
        state.roomLoading = true;
      })
      .addCase(AdminGetNormalRooms.fulfilled, (state, { payload }) => {
        state.roomLoading = false;
        state.normalRooms = payload.data;
        state.roomMessage = payload.message;
      })
      .addCase(AdminGetNormalRooms.rejected, (state, { payload }) => {
        state.roomLoading = false;
        state.roomMessage = payload.message;
      });

    builder
      .addCase(AdminUploadImages.pending, (state) => {
        state.roomImageLoader = true;
      })
      .addCase(AdminUploadImages.fulfilled, (state, { payload }) => {
        state.roomImageLoader = false;
        state.roomMessage = payload.message;
        state.roomImageDetails = payload.data;
      })
      .addCase(AdminUploadImages.rejected, (state, { payload }) => {
        state.roomImageLoader = false;
        state.roomMessage = payload?.message;
      });
  },
});

export const {
  reset,
  updateRoom,
  updateNormalRoom,
  updateCurrentRoom,
  updateCurrentNormalRoom,
  updateMessage,
  updateSelectedRoom,
  updateSelectedNormalRoom,
  updateRoomMessageDetails,
} = adminRoomSlice.actions;
export const roomSelector = (state) => state.admin_room;

export default adminRoomSlice.reducer;
